const INITIAL_STATE = {
  logs: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DEVELOP_LOGGER_GRID': {
      return { ...state, logs: [...action.payload] };
    }
    default:
      return state;
  }
};
